import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from '../images/RAYNOLOGO.png';
import logo2 from '../images/RAYNOLOGO2.png';
import userIcon from '../images/userIcon.png';
import '../../main.css';

function NavbarMain() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('tokenhossein');
    alert('شما با موفقیت خارج شدید.');
    navigate('/Login'); // ناوبری به صفحه ورود
  };

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse) {
      navbarCollapse.classList.remove("show");
    }
  };

  return (
    <div className="navbar-custom fixed-top">
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <Link to="/" className="navbar-brand"onClick={closeNavbar}>
              <img src={logo2} alt="RAYNO Logo" style={{ height: '60px' }} />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link to="/AboutUs" className="nav-link navbar-font-color"onClick={closeNavbar}>درباره ما</Link>
                </li>
                <li className="nav-item">
                  <Link to="/Products" className="nav-link navbar-font-color"onClick={closeNavbar}>محصولات</Link>
                </li>
                <li className="nav-item">
                  <Link to="/Notifications" className="nav-link navbar-font-color"onClick={closeNavbar}>اخبار/اطلاعیه</Link>
                </li>
                <li className="nav-item">
                  <Link to="/Education" className="nav-link navbar-font-color"onClick={closeNavbar}>آموزش</Link>
                </li>
                <li className="nav-item">
                  <Link to="/FAQ" className="nav-link navbar-font-color"onClick={closeNavbar}>پرسش و پاسخ</Link>
                </li>
                <li className="nav-item">
                  <Link to="/SupportOnline" className="nav-link navbar-font-color"onClick={closeNavbar}>پشتیبانی آنلاین</Link>
                </li>
                <li className="nav-item">
                  <Link to="/ContactUs" className="nav-link navbar-font-color"onClick={closeNavbar}>تماس با ما</Link>
                </li>
              </ul>
           
              <div className="d-none d-lg-block ms-3">
              <Link to="/login" className="btn btn-outline-dark "style={{ fontFamily: 'Vazir' }}>
                  <img src={userIcon} alt="ورود کاربران" style={{width: '20px', marginRight: '5px' }} />
                  ورود کاربران
                </Link>
              </div>

              <div className="d-lg-none">
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <Link to="/login" className="nav-link  navbar-font-color"onClick={closeNavbar}>ورود کاربران</Link>
                  </li>
                </ul>
              </div>

              
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default NavbarMain;
